import React from 'react';
import { Box } from '@mui/material';
import Content from './ZipFinder/Content';

export default function ZipFinder() {
  return <Content />;
}
